import { get } from "lodash";

export default class DefinitionValue {
  id?: string;
  name: string;
  value: string;

  constructor(params?: DefinitionValue) {
    this.id = get(params, "id");
    this.name = get(params, "name", "");
    this.value = get(params, "value", "");
  }
}
